(ns ballot-scout-v2-frontend.api-urls
  (:require-macros
   [ballot-scout-v2-frontend.config-helpers :refer [required-env-var]]))

(def base-url
  "Base URL for the Ballot Scout API."
  (required-env-var :ballot-api-url))

(defn ballot-scout-url
  [& args]
  (apply str base-url args))

(def all-partners (ballot-scout-url "/partners"))

(defn partner-by-id-or-slug
  "/partners/:id-or-slug"
  [id-or-slug]
  (ballot-scout-url "/partners/" id-or-slug))

(defn jurisdiction-by-id-or-slug
  "/jurisdictions/:id-or-slug"
  [id-or-slug]
  (ballot-scout-url "/jurisdictions/" id-or-slug))

; public facing ballot search -- used by widget
(defn ballot-search []
  (ballot-scout-url "/ballot-search"))

; public facing voter search -- used by widget
(defn voter-search []
  (ballot-scout-url "/voter-search"))

(defn voter-email-subscribe
  "/jurisdictions/:jurisdiction-id/voters/:voter-id/email/subscribe"
  [jurisdiction-id voter-id]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id "/voters/" voter-id "/email/subscribe"))

(defn voter-email-unsubscribe
  "/jurisdictions/:jurisdiction-id/voters/:voter-id/email/unsubscribe"
  [jurisdiction-id voter-id]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id "/voters/" voter-id "/email/unsubscribe"))

(defn voter-sms-subscribe
  "/jurisdictions/:jurisdiction-id/voters/:voter-id/sms/subscribe"
  [jurisdiction-id voter-id]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id "/voters/" voter-id "/sms/subscribe"))

(defn voter-sms-unsubscribe
  "/jurisdictions/:jurisdiction-id/voters/:voter-id/sms/unsubscribe"
  [jurisdiction-id voter-id]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id "/voters/" voter-id "/sms/unsubscribe"))

(defn check-stopcode-received []
  (ballot-scout-url "/check-stopcode-received"))

(defn verify-email
  "/verify-email"
  [user-token]
  (ballot-scout-url "/verify-email?user-token=" user-token))

(defn unsubscribe-email
  "/unsubscribe-email"
  [user-token]
  (ballot-scout-url "/unsubscribe-email?user-token=" user-token))

(defn widget-jurisdiction-data [jurisdiction-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-slug "/config-details"))

(defn widget-partner-data [partner-slug]
  (ballot-scout-url "/partners/" partner-slug "/config-details"))

; user site voter lookup page
(defn ballots-for-jurisdiction
  "/jurisdictions/:jurisdiction-id-or-slug/ballots"
  [jurisdiction-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug "/ballots"))

(defn ballots-for-partner
  "/partners/:partner-id/ballots"
  [partner-id]
  (ballot-scout-url "/partners/" partner-id "/ballots"))

(defn ballot-export-for-jurisdiction
  "/jurisdictions/:jurisdiction-id/ballot-export"
  [jurisdiction-id]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id "/ballot-export"))

(defn ballot-export-for-partner
  "/partners/:partner-id/ballot-export"
  [partner-id]
  (ballot-scout-url "/partners/" partner-id "/ballot-export"))

(defn days-in-service-export-for-jurisdiction
  "/jurisdictions/:jurisdiction-id-or-slug/elections/:election-id-or-slug/days-in-service-export"
  [jurisdiction-id-or-slug election-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug
                    "/elections/" election-id-or-slug
                    "/days-in-service-export"))

(defn days-in-service-export-for-partner
  "/partners/:partner-id-or-slug/elections/:election-id-or-slug/days-in-service-export"
  [partner-id-or-slug election-id-or-slug]
  (ballot-scout-url "/partners/" partner-id-or-slug
                    "/elections/" election-id-or-slug
                    "/days-in-service-export"))

(defn export-job-for-jurisdiction
  "/jurisdictions/:jurisdiction-id/exports/:job-id"
  [jurisdiction-id job-id]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id "/exports/" job-id))

(defn export-job-for-partner
  "/partners/:partner-id/exports/:job-id"
  [partner-id job-id]
  (ballot-scout-url "/partners/" partner-id "/exports/" job-id))

(defn ballot-history
  "/jurisdictions/:jurisdiction-id-or-slug/ballots/:ballot-id/history"
  [jurisdiction-id-or-slug ballot-id]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug "/ballots/" ballot-id "/history"))

; user site dashboard
(defn ballots-by-status-and-jurisdiction
  "/jurisdictions/:jurisdiction-id-or-slug/elections/:election-id-or-slug/ballots-by-status"
  [jurisdiction-id-or-slug election-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug
                    "/elections/" election-id-or-slug
                    "/ballots-by-status"))

(defn ballots-by-status-and-partner
  "/partners/:partner-id-or-slug/elections/:election-id-or-slug/ballots-by-status"
  [partner-id-or-slug election-id-or-slug]
  (ballot-scout-url "/partners/" partner-id-or-slug
                    "/elections/" election-id-or-slug
                    "/ballots-by-status"))

(defn days-in-service-by-jurisdiction
  "/jurisdictions/:jurisdiction-id-or-slug/elections/:election-id-or-slug/days-in-service"
  [jurisdiction-id-or-slug election-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug
                    "/elections/" election-id-or-slug
                    "/days-in-service"))

(defn days-in-service-by-partner
  "/partners/:partner-id-or-slug/elections/:election-id-or-slug/days-in-service"
  [partner-id-or-slug election-id-or-slug]
  (ballot-scout-url "/partners/" partner-id-or-slug
                    "/elections/" election-id-or-slug
                    "/days-in-service"))

(defn ballots-by-location-and-jurisdiction
  "/jurisdictions/:id-or-slug/elections/:election-id-or-slug/ballots-by-location"
  [jurisdiction-id-or-slug election-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug "/elections/" election-id-or-slug "/ballots-by-location"))

(defn ballots-by-location-and-partner
  "/partners/:id-or-slug/elections/:election-id-or-slug/ballots-by-location"
  [partner-id-or-slug election-id-or-slug]
  (ballot-scout-url "/partners/" partner-id-or-slug "/elections/" election-id-or-slug "/ballots-by-location"))

(defn noty-stats-by-jurisdiction
  "/jurisdictions/:id-or-slug/elections/:election-id-or-slug/notification-stats"
  [jurisdiction-id-or-slug election-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug "/elections/" election-id-or-slug "/notification-stats"))

(defn noty-stats-by-partner
  "/partners/:id-or-slug/elections/:election-id-or-slug/notification-stats"
  [partner-id-or-slug election-id-or-slug]
  (ballot-scout-url "/partners/" partner-id-or-slug "/elections/" election-id-or-slug "/notification-stats"))

; user site navigation
(defn elections-for-jurisdiction
  "/jurisdictions/:id-or-slug/elections"
  [id-or-slug]
  (ballot-scout-url "/jurisdictions/" id-or-slug "/elections"))

(defn elections-for-partner
  "/partners/:id-or-slug/elections"
  [id-or-slug]
  (ballot-scout-url "/partners/" id-or-slug "/elections"))

(defn resource-urls []
  (ballot-scout-url "/resources"))

; user site imports
(defn new-import-upload
  "/jurisdictions/:jurisdiction-id-or-slug/elections/:election-id-or-slug/imports"
  [jurisdiction-id-or-slug election-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug "/elections/" election-id-or-slug "/imports"))

(def imports-list new-import-upload)

(defn import-by-id
  "/imports/:import-id"
  [import-id]
  (ballot-scout-url "/imports/" import-id))

(defn set-import-column-mapping
  "/imports/:import-id/set-column-mapping"
  [import-id]
  (ballot-scout-url "/imports/" import-id "/set-column-mapping"))

(defn set-imb-generation
  "/imports/:import-id/set-imb-generation"
  [import-id]
  (ballot-scout-url "/imports/" import-id "/set-imb-generation"))

(defn set-reissue-ballot-config
  "/imports/:import-id/set-reissue-ballot-config"
  [import-id]
  (ballot-scout-url "/imports/" import-id "/set-reissue-ballot-config"))

(defn start-import
  "/imports/:import-id/start"
  [import-id]
  (ballot-scout-url "/imports/" import-id "/start"))

; user site dispositions
(defn new-disposition-upload-for-jurisdiction
  "/jurisdictions/:jurisdiction-id-or-slug/elections/:election-id-or-slug/dispositions"
  [jurisdiction-id-or-slug election-id-or-slug]
  (ballot-scout-url "/jurisdictions/" jurisdiction-id-or-slug "/elections/" election-id-or-slug "/dispositions"))

(defn new-disposition-upload-for-partner
  "/partners/:partner-id-or-slug/elections/:election-id-or-slug/dispositions"
  [partner-id-or-slug election-id-or-slug]
  (ballot-scout-url "/partners/" partner-id-or-slug "/elections/" election-id-or-slug "/dispositions"))

(def dispositions-list-for-jurisdiction new-disposition-upload-for-jurisdiction)

(def dispositions-list-for-partner new-disposition-upload-for-partner)

(defn disposition-by-id
  "/dispositions/:disposition-id"
  [dispo-id]
  (ballot-scout-url "/dispositions/" dispo-id))

(defn set-disposition-column-mapping
  "/dispositions/:disposition-id/set-column-mapping"
  [dispo-id]
  (ballot-scout-url "/dispositions/" dispo-id "/set-column-mapping"))

(defn cancel-disposition
  "/dispositions/:disposition-id/cancel"
  [dispo-id]
  (ballot-scout-url "/dispositions/" dispo-id "/cancel"))

(defn start-disposition
  "/dispositions/:disposition-id/start"
  [dispo-id]
  (ballot-scout-url "/dispositions/" dispo-id "/start"))

; stats
(defn ballot-stats []
  (ballot-scout-url "/global-stats/ballots"))

(defn dispo-stats []
  (ballot-scout-url "/global-stats/dispo"))

(defn election-stats []
  (ballot-scout-url "/global-stats/elections"))

(defn notys-stats []
  (ballot-scout-url "/global-stats/notifications"))

(defn usps-stats []
  (ballot-scout-url "/global-stats/scans"))

(defn subs-stats []
  (ballot-scout-url "/global-stats/subs"))
